<!-- @format -->

<section
	id="reviews-responsive-summary"
	class="reviews-responsive-summary hmf-display-flex hmf-flex-column hmf-flex-m-row"
	[attr.itemscope]="renderSEO() ? true : undefined"
	[attr.itemprop]="renderSEO() ? 'aggregateRating' : undefined"
	[attr.itemtype]="renderSEO() ? 'https://schema.org/AggregateRating' : undefined"
	[ngClass]="{
		'hmf-px-s': isDrawer(),
		'hmf-pl-l-s': !isDrawer()
	}">
	@if (renderSEO() && productName()) {
		<div
			itemscope
			itemprop="itemReviewed"
			itemtype="https://schema.org/IndividualProduct">
			<meta
				itemprop="name"
				content="{{ productName() }}" />
		</div>
	}
	<div
		class="rating-information hmf-display-flex hmf-flex-column hmf-align-items-center hmf-span-s-12 hmf-span-m-4"
		[ngClass]="{
			'hmf-mr-xxxxl hmf-ml-m-xxs': !isDrawer(),
			slim: !isDrawer() && (!percentage() || !rating())
		}">
		<div class="rating-information-inner-container hmf-display-flex hmf-mb-m-xs">
			@if (rating()) {
				<div class="hmf-display-flex hmf-flex-column hmf-align-items-center hmf-flex-grow">
					<p
						class="reviews-responsive-summary-rating-number hmf-header-bold-xl hmf-m-0"
						data-nosnippet>
						{{ rating() | starRatingNumber: hasNewReviewsEnhancement() }}
					</p>
					@if (renderSEO()) {
						<meta
							itemprop="ratingValue"
							[attr.content]="
								rating() | starRatingNumber: hasNewReviewsEnhancement()
							" />
					}
					<product-reviews-review-stars
						class="hmf-display-inline-flex hmf-mt-xxxs"
						[rating]="rating()"
						[options]="starsOptions()"></product-reviews-review-stars>
				</div>
			}
			@if (percentage()) {
				<div class="hmf-display-flex hmf-flex-grow hmf-flex-column hmf-align-items-center">
					<p
						class="reviews-responsive-summary-percentage-number hmf-m-0 hmf-header-bold-xl">
						{{ percentage() | number: '1.0-0' }}%
					</p>
					<p class="hmf-subheader-m hmf-m-0 hmf-mt-xxxs">Recommended</p>
				</div>
			}
		</div>
		@if (renderSEO() && overallRatingRange()) {
			<meta
				itemprop="bestRating"
				content="{{ overallRatingRange() }}" />
		}
		<p
			class="reviews-responsive-summary-count-number hmf-body-m hmf-mb-0 hmf-mt-0 hmf-mt-xxs hmf-mt-m-0"
			data-nosnippet>
			{{ count() | number: '1.0-1' }} Reviews
		</p>
		@if (renderSEO()) {
			<meta
				itemprop="reviewCount"
				[attr.content]="count()" />
		}
	</div>

	<product-reviews-secondary-rating
		class="secondary-ratings"
		[ngClass]="{
			'hmf-col hmf-span-s-12 hmf-span-m-5 hmf-mr-m-m hmf-ml-m-m hmf-mr-l-xl hmf-px-m-xxs':
				isDrawer()
		}">
	</product-reviews-secondary-rating>

	@if (isDrawer()) {
		<product-reviews-review-button
			class="write-a-review-button hmf-mt-m hmf-mt-m-0 hmf-pl-s hmf-span-12 hmf-span-m-4 hmf-flex hmf-flex-row hmf-justify-content-center hmf-justify-content-m-flex-end"
			[label]="writeAReviewLabel()"
			[type]="writeAReviewType()"
			[isDrawer]="true">
		</product-reviews-review-button>
	}
</section>
